import clsx from 'clsx';

/**
 * One placeholder bar, sized with classes (`h-4 w-32`) to the content it stands in for.
 * Decorative: the `SkeletonRegion` around it is what announces the load.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={clsx('animate-pulse rounded-md bg-fg/10 motion-reduce:animate-none', className)} />;
}
